import React, { useEffect } from "react";

import Image from "@atoms/Image";

export default function WeChat() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <Image className="center pc:w-1/3 fixed! w-2/3" height={1280} loading="eager" src="/tnt_wechat_qr.webp" width={1280} />;
}
